import React, { useState, useEffect } from 'react'

import UsersService from 'Services/users'
import { useQueryParams } from 'raviger'
import { toastWithErrorMessage } from 'Helpers/toast'

import Separator from 'Components/shared/Separator'
import UpdateUserForm from './Forms/Update'
import { VirtualOfficeTableUser } from '../VirtualOffices/Table'
import AddVirtualOffice from './Forms/Add-Virtual-Office'

export default () => {
  const [{ id }] = useQueryParams()
  const [user, setUser] = useState()

  useEffect(async () => {
    setUser(
      await UsersService.get({ userId: id }).catch(toastWithErrorMessage('Failed to get user info'))
    )
  }, [])

  return (
    <>
      {user && (
        <>
          <UpdateUserForm user={user} setUser={setUser} />
          <Separator />
          <AddVirtualOffice user={user} setUser={setUser} />
          <VirtualOfficeTableUser user={user} setUser={setUser} />
        </>
      )}
    </>
  )
}
